"use strict";
exports.__esModule = true;
exports.tryRegisterSW = void 0;
var tslib_1 = require("tslib");
function tryRegisterSW(path) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var registration, error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!("serviceWorker" in navigator)) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.serviceWorker.register(path)];
                case 2:
                    registration = _a.sent();
                    console.log("Service worker registration succeeded at ".concat(path, ":"), registration);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error("Service worker registration failed: ".concat(error_1));
                    throw error_1;
                case 4: return [3 /*break*/, 6];
                case 5: throw new Error("Service workers are not supported.");
                case 6: return [2 /*return*/];
            }
        });
    });
}
exports.tryRegisterSW = tryRegisterSW;
